module.exports = __webpack_public_path__ + "img/bsidd-2.bc252947.webp";